import React from "react";

const BrandingContext = React.createContext({
  siteName: "",
  primaryColor: "#2576d2",
  logoUrl: "",
  gradientStart: "",
  gradientEnd: ""
});

export default BrandingContext;

